<template>
    <div>
            <el-form :model="info" :rules="rules" ref="ruleForm" @submit.native.prevent style="padding: 30px 0 0 0;text-align:center;font-size: 14px">
                <el-form-item style="width: 100%;height: auto;">
                    <img :src="imgSrc" width="280" height="150" @click="validateImageInit"/>
                </el-form-item>
                <el-form-item prop="code" style="width: 100%;height: auto;">
                    <input type="text" v-model.trim="info.code" maxlength="4"
                           @keydown.enter="check">
                </el-form-item>
                <button type="button" @click="check">Continue</button>
            </el-form>
    </div>
</template>

<script>
    import util from '../util'
    import config from '../config'
    import store from "../store";
    export default {
        name: "verifyImage2",
        data() {
            return {
                rules: {
                    code: [{required: true, message: 'Can\'t be empty', trigger: 'blur'}]
                },
                imgSrc: '',
                info:{
                    code: ''
                }
            }
        },
        mounted() {
            this.validateImageInit();
        },
        methods: {
            validateImageInit() {
                util.axios.post(config.verify_image_url2)
                    .then((data) => {
                        if (data) {
                            this.imgSrc = `data:image/png;base64,${data}`
                        } else
                            this.validateImageInit()
                    }).catch(() => this.validateImageInit())
            },
            check(){
                this.$refs.ruleForm.validate(v=>{
                    if(v){
                        util.axios.post(`${config.do_verify_url2}/${this.info.code}`)
                            .then(data=>{
                                if(data === true){
                                    this.$emit("verified")
                                }else{
                                    this.$store.commit('message', 'Verification code error')
                                    this.validateImageInit()
                                }
                            })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
